import React, { useEffect, useState } from "react";
import {
  BarcodeOutlined,
  CarOutlined,
  CarryOutOutlined,
  FileSearchOutlined,
  QrcodeOutlined,
  UserOutlined,
  FileOutlined, BarChartOutlined,
} from "@ant-design/icons";
import { BiCopy, BiTransfer } from "react-icons/bi";
import { VscLiveShare } from "react-icons/vsc";
import { RiFolderTransferLine } from "react-icons/ri";
import {
  FaClipboardList,
  FaFileContract,
  FaHandHoldingUsd,
  FaHistory,
  FaRegCreditCard,
} from "react-icons/fa";
import { BsBoxArrowUp, BsCardList } from "react-icons/bs";
import {
  AiOutlineFilePdf,
  AiOutlineProfile,
  AiFillCreditCard,
} from "react-icons/ai";
import {
  MdOutlineAccountBalanceWallet, MdOutlineMoneyOff,
  MdOutlinePointOfSale,
  MdOutlineRequestPage, MdOutlineTextSnippet,
} from "react-icons/md";
import { Sider, Logo, TecpayLogo, Menu, SubMenu, Item, Link } from "../styles";
import { ISideMenuProps } from "../types";
import { RoutesEnum } from "../../../routes/types";
import { IConfigData } from "../../../store/config/types";
import { isHiddenFeatureDomain } from "../../../config";
import { PortalPermissions, can, canAny } from "../../../config/permissions";
import logo from "../../../assets/tecpay-no-bg.png";
import { CiMoneyBill } from "react-icons/ci";
import { LiaFileSignatureSolid } from "react-icons/lia";
import useGetMe from "../../../hooks/useCurrentUser";
import { FaFileCircleCheck } from "react-icons/fa6";

const SideMenu: React.FC<ISideMenuProps> = (props: ISideMenuProps) => {
  const screenSize = window.screen.width;
  const { collapsed } = props;
  const [primaryColor, setPrimaryColor] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const user = useGetMe();

  const selectedBusiness = localStorage.getItem("selectedCompany")
    ? JSON.parse(localStorage.getItem("selectedCompany") as string)
    : null;
  const commercialHierId = selectedBusiness?.commercialHierId;

  useEffect(() => {
    const domain = window.location.hostname;
    const cachedConfig: IConfigData = JSON.parse(
      localStorage.getItem(`config_${domain}`) as string
    );
    if (cachedConfig) {
      setPrimaryColor(cachedConfig.corPrimaria);
      setLogoUrl(cachedConfig.linkImagem2);
    } else {
      setPrimaryColor("#0e2b27");
    }
  }, []);

  return (
    <Sider
      width={screenSize > 768 ? 230 : 130}
      className="site-layout-background"
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{ backgroundColor: primaryColor }}
    >
      <Logo to="/painel-de-vendas">
        <TecpayLogo src={logoUrl} />
      </Logo>
      <Menu
        mode="inline"
        theme="dark"
        style={{ backgroundColor: primaryColor }}
      >
        {commercialHierId !== 290 && !isHiddenFeatureDomain()
          && can(PortalPermissions.conta.acessoConta.acessar) && (
          <Item icon={<UserOutlined />} key="">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://banking.valori.com.vc/login"
          >
            <b>Acesso à conta</b>
          </a>
        </Item>
        )}

        {selectedBusiness?.allowPaymentLink
          && canAny(PortalPermissions.linkPagamento.historico.acessar, PortalPermissions.linkPagamento.gerar.acessar) && (
          <SubMenu
            key="linkpagamento"
            title="Link de pagamento"
            icon={<BiTransfer />}
          >
            {can(PortalPermissions.linkPagamento.historico.acessar) && (
              <Item icon={<VscLiveShare />} key="listarlinks">
                <Link to="/listar-links">Histórico de links</Link>
              </Item>
            )}
            {can(PortalPermissions.linkPagamento.gerar.acessar) && (
              <Item icon={<VscLiveShare />} key="cadastrarlinks">
                <Link to="/cadastrar-links">Gerar Link</Link>
              </Item>
            )}
          </SubMenu>
        )}

        {selectedBusiness?.allowPaymentLink
          && canAny(PortalPermissions.assinaturas.historico.acessar, PortalPermissions.assinaturas.gerar.acessar) && (
          <SubMenu key="assinatura" title="Assinaturas" icon={<BiTransfer />}>
            {can(PortalPermissions.assinaturas.historico.acessar) && (
              <Item icon={<VscLiveShare />} key="listarAssinaturas">
                <Link to="/listar-assinaturas">Histórico de assinaturas</Link>
              </Item>
            )}
            {can(PortalPermissions.assinaturas.gerar.acessar) && (
              <Item icon={<VscLiveShare />} key="cadastrarAssinaturas">
                <Link to="/cadastrar-assinaturas">Gerar assinaturas</Link>
              </Item>
            )}
          </SubMenu>
        )}

        {can(PortalPermissions.transacoes.vendas.acessar) && (
          <Item icon={<VscLiveShare />} key="painelVendas">
            <Link to="/painel-de-vendas">Vendas</Link>
          </Item>
        )}
        {can(PortalPermissions.transacoes.recebiveis.acessar) && (
          <Item icon={<VscLiveShare />} key="painelRecebiveis">
            <Link to="/painel-de-recebiveis">Recebíveis</Link>
          </Item>
        )}
        {!isHiddenFeatureDomain()
          && canAny(PortalPermissions.simulador.recebimento.acessar, PortalPermissions.simulador.venda.acessar) && (
          <SubMenu key="simulador" title="Simulador" icon={<BiTransfer />}>
            {can(PortalPermissions.simulador.recebimento.acessar) && (
              <Item key="simulador-recebimento">
                <Link to="/simulador/recebimento">Quero receber</Link>
              </Item>
            )}
            {can(PortalPermissions.simulador.venda.acessar) && (
              <Item key="simulador-venda">
                <Link to="/simulador/venda">Quero vender por</Link>
              </Item>
            )}
          </SubMenu>
        )}

        <SubMenu
          key="gestaoCobranca"
          title="Gestão de Cobranças"
          icon={<CiMoneyBill />}
        >
          {can(PortalPermissions.cobrancas.menu.acessar) && (
            <Item icon={<MdOutlinePointOfSale />} key="menuCobrancas">
              <Link to="/menu-cobrancas">Menu de Cobranças</Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.produtosContratados.acessar) && (
            <Item icon={<LiaFileSignatureSolid />} key="assinaturas">
              <Link to="/produtos">Produtos Contratados</Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.cobrancaPontual.acessar) && (
            <Item icon={<MdOutlinePointOfSale />} key="cobrancaAvulsa">
              <Link to="/cobranca-avulsa"> Cobrança Pontual</Link>
            </Item>
          )}

          {/*{selectedBusiness.anticipationIncluded == false && (*/}
          {/*  <Item icon={<FaHandHoldingUsd />} key="antecipacao">*/}
          {/*    <Link to="/antecipacao">Antecipação Pontual</Link>*/}
          {/*  </Item>*/}
          {/*)}*/}

          {selectedBusiness.anticipationIncluded == false
            && can(PortalPermissions.cobrancas.historicoAntecipacao.acessar) && (
            <Item icon={<FaHistory />} key="historicoAntecipacao">
              <Link to="/admin/historico-antecipacao">
                Histórico de Antecipações
              </Link>
            </Item>
          )}

          {can(PortalPermissions.cobrancas.chargebacks.acessar) && (
            <Item icon={<FaHandHoldingUsd />} key="chargeback">
              <Link to="/admin/chargeback">
                Chargebacks
              </Link>
            </Item>
          )}
        </SubMenu>

        {can(PortalPermissions.contratos.efeitosCumpridos.acessar) && (
          <SubMenu
            key="efeitoContrato"
            title="Efeitos de Contrato"
            icon={<FaFileContract />}
          >
            <Item icon={<FaFileCircleCheck />} key="efeitoContrato">
              <Link to="/admin/efeito-contrato">Efeitos Cumpridos</Link>
            </Item>
          </SubMenu>
        )}

        {selectedBusiness.splitEnabled && can(PortalPermissions.financeiro.extrato.acessar) && (
          <Item icon={<BarChartOutlined/>} key="paymentStatement">
            <Link to="/extrato">
              Extrato
            </Link>
          </Item>
        )}

        {can(PortalPermissions.financeiro.taxas.acessar) && (
          <Item key="fees" icon={<MdOutlineMoneyOff/>}>
            <Link to="/fees">Taxas</Link>
          </Item>
        )}

        {can(PortalPermissions.contratos.contratosTermos.acessar) && (
          <Item key="contracts" icon={<MdOutlineTextSnippet />}>
            <Link to="/contracts-history">Contratos e termos</Link>
          </Item>
        )}
      </Menu>
    </Sider>
  );
};

export default SideMenu;
